export default "__VITE_ASSET__DhcFHbI2__"